import * as React from 'react';

interface UseQuestionTimerProps {
  timeLimit: number;
  onTimeExpired: () => void;
}

export const useQuestionTimer = ({
  timeLimit,
  onTimeExpired,
}: UseQuestionTimerProps) => {
  const [timeRemaining, setTimeRemaining] = React.useState(timeLimit);
  const [timeExpired, setTimeExpired] = React.useState(false);

  React.useEffect(() => {
    if (timeLimit > 0 && timeRemaining > 0 && !timeExpired) {
      const timer = setInterval(() => {
        setTimeRemaining((prev) => {
          if (prev <= 1) {
            setTimeExpired(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
    return undefined;
  }, [timeLimit, timeRemaining, timeExpired]);

  React.useEffect(() => {
    if (timeExpired) {
      onTimeExpired();
    }
  }, [timeExpired, onTimeExpired]);

  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  return {
    timeRemaining,
    timeExpired,
    formatTime,
  };
};
